import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBigSmile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.29961 9.89961H8.09961M15.8996 9.89961H14.6996M21.8996 11.9996C21.8996 17.4672 17.4672 21.8996 11.9996 21.8996C6.53199 21.8996 2.09961 17.4672 2.09961 11.9996C2.09961 6.53199 6.53199 2.09961 11.9996 2.09961C17.4672 2.09961 21.8996 6.53199 21.8996 11.9996ZM15.2996 15.2996C14.0996 18.8996 9.89961 18.8996 8.69961 15.2996H15.2996Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgBigSmile);
export { ForwardRef as ReactComponent };
